import type { TrendListResponsePageAllOf } from './trendListResponsePageAllOf';
import type { TrendListResponsePageAllOfThree } from './trendListResponsePageAllOfThree';

export type TrendListResponsePage = TrendListResponsePageAllOf & TrendListResponsePageAllOfThree;
